import { Server } from '../../server/Server';
import Crud , { registerCrudClassProxy, IAsTextResult, IListParams, CrudClassProxy, ISearchTextParams, ISearchTextResult } from '../Crud';

export interface IExerciseRecord {
    /**
     * Globálisan egyedi azonosító.
     * 
     * Ha új rekordot akarsz létrehozni put() metódussal, akkor hagyd üresen.
     * upsert() hívásnál figyelmen kívül van hagyva az értéke.
     *
     */
    id ?: number;
    /**
     * Név
     */
    name?: string;
    /**
     * Feladat motor
     *
     * NOT NULL -> exc.engine ON DELETE cascade
     *
     */
    engine_id?: number;
    /**
     * Évfolyam
     *
     * -> doc.grade ON DELETE cascade
     *
     */
    grade_id?: number|null;
    /**
     * Tantárgy
     *
     * -> doc.subject ON DELETE cascade
     *
     */
    subject_id?: number|null;
    /**
     * Könyvtár
     *
     * NOT NULL -> doc.library ON DELETE cascade
     *
     */
    library_id?: number;
    /**
     * A feladat adatai
     */
    exercise?: any;
    /**
     * A feladat helyes megoldása
     */
    solution?: any;
    /**
     * Utasítás
     */
    task_html?: string|null;
    /**
     * Visszajelzés helyes válaszra
     */
    correct_answer_feedback_html?: string|null;
    /**
     * Visszajelzés helytelen válaszra
     */
    wrong_answer_feedback_html?: string|null;
    /**
     * Tároló
     *
     * -> media_pub.oo_folder ON DELETE noaction
     *
     *
     * Az a mappa, ami a feladathoz tartozó médiákat tárolja.
     */
    oo_folder_id?: number|null;
    /**
     * Megjelenés helye
     *
     * -> media_pub.oo_folder ON DELETE setnull
     *
     *
     * Mappa, ahol a feladat a virtuális állományrendszerben megjelenik.
     */
    show_in_folder_id?: number|null;
    /**
     * Név
     *
     * Kulcsszavak
     */
    keywords?: string|null;
    /**
     * A feladat mentésekor ide bekerül az összes olyan szöveg, ami értelmes kereshető szöveget tartalmaz. Ez feladatmotoronként eltérő helyekről/mezőkből származik.
     *
     * Kereső szöveg
     */
    search_text?: string|null;
    /**
     * SNI
     *
     * Sajátos nevelési igényűek számára készített feladat
     */
    is_sni?: boolean;
    /**
     * Akadálymentesített
     *
     * Látássérültek számára akadálymentesített feladat
     */
    is_accessible?: boolean|null;
    /**
     * Egyszerû megjelenítés
     *
     * Egyszerű stílusban megjelenítendő feladat
     */
    simple_style?: boolean|null;
    /**
     * Site
     *
     * NOT NULL -> cms.site ON DELETE noaction
     *
     */
    site_id?: number;
    /**
     * Nyelv
     *
     * NOT NULL -> sys.lang ON DELETE cascade
     *
     */
    lang_id?: number;
}

/**
 *  exc_pub.exercise - Feladat
 *
 *  A feladat egy konkrét feladvány, amit egy előre meghatározott feladat motor jelenít meg.
 */

export default class ExerciseCrud extends Crud<IExerciseRecord> {
    public static TABLE_INFO_ID = 1205255445;
    public static getSchemaNameForClass() { return 'exc_pub'; }
    public static getTableNameForClass() { return 'exercise'; }

    public static canCache(): boolean {
        return true;
    }

    public static getDefaultMaxAge() : number|undefined {
        return 3600;
    }

    public static load: (id: number, aServer ?: Server) => Promise<ExerciseCrud>;
    public static asText: (id: number, includeRecord : boolean, aServer ?: Server) => Promise<IAsTextResult<IExerciseRecord>>;
    public static list: (params: IListParams, aServer ?: Server) => Promise<IExerciseRecord[]>;
    public static searchText: (params: ISearchTextParams, aServer ?: Server) => Promise<ISearchTextResult<IExerciseRecord>[]>;
    public static deleteById: (id: number, aServer ?: Server) => Promise<IExerciseRecord>;
    public static unDeleteById: (id: number, aServer ?: Server) => Promise<IExerciseRecord>;
}

/**
 * Class for a class proxy object that can emulate virtual class methods.
 */
export class ExerciseCrudClassProxy extends CrudClassProxy<IExerciseRecord> {
}
/**
 * A singleton that emulates virtual classmethods of the corresponding Crud class.
 */
export const exerciseCrudClassProxy = new ExerciseCrudClassProxy(ExerciseCrud);
registerCrudClassProxy(exerciseCrudClassProxy);
